module.exports = __webpack_public_path__ + "static/media/bfile-cd.c0ed5f8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-cd.svg
// module id = 252
// module chunks = 0